import { render, staticRenderFns } from "./_ViewTab.vue?vue&type=template&id=2ab3ec37"
import script from "./_ViewTab.vue?vue&type=script&lang=ts"
export * from "./_ViewTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports